import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import EmpDashboard from "./dashboard/empdashboard";
import RequestLeaveForm from "./components/RequestLeaveForm";
import AllLeaves from "./components/AllLeaves";
import AdminDashboard from "./dashboard/AdminDashboard";
import ApproveLeaveRequests from "./components/ApproveLeaveRequests";
import AddEmployee from "./components/AddEmployee";
import AllEmployees from "./components/AllEmployees";
import EditEmployee from "./components/EditEmployee";
import UploadDocuments from "./components/UploadDocs";
import TrainingForm from "./components/CertificationForm";
import DepartmentForm from "./masters/Department";
import DesignationForm from "./masters/Designation";
import LeaveTypeForm from "./masters/Leave";
import DocumentCRUD from "./masters/Document";
import UploadDocument from "./components/UploadDocuments";
import ViewDocuments from "./components/ViewDocuments";
import RoleCRUD from "./masters/Roles";
import EditProfile from "./components/EditProfile";
import ManagerDashboard from "./dashboard/ManagerDashboard";
import ViewTasks from "./components/ViewTasks";
import RegisterEmployee from "./dashboard/RegisterEmployee";
import ManageUsers from "./dashboard/ManageUsers";
import LeaveList from "./components/LeaveList";
import HRDashboard from "./dashboard/HRDashboard";
import AssignLeaves from "./components/AssignLeaves";
import ViewLeaveCreditLogs from "./components/ViewLeaveCreditLogs";
import AdminDocuments from "./components/AdminDocuments";
import ViewTaskss from "./components/ViewTaskss";
import AdminViewTasks from "./dashboard/AdminViewTasks";
import AdminReports from "./dashboard/AdminReports";
import TimesheetGrid from "./components/TimesheetGrid";
import AdminTimesheetGrid from "./dashboard/AdminTimesheetGrid";
import ManagerTimesheetGrid from "./dashboard/ManagerTimesheetGrid";
import HRLetterGenerator from "./dashboard/HRLetterGenerator";
import KanbanBoard from "./dashboard/KanbanBoard";
import EmployeeFacilities from "./components/EmployeeFacilities";
import ManagerFacilities from "./components/ManagerFacilities";
import AdminFacilities from "./components/AdminFacilities";
import AdminProfile from "./dashboard/AdminProfile";
import TeamTimesheetGrid from "./dashboard/TeamTimesheetGrid";
import AdminNavbar from "./Layout/AdminNavbar";
import EmployeeView from "./components/ViewEmployee";
import ProtectedRoute from "./ProtectedRoute";
import EmpProtectedRoute from "./EmpProtectedRoute";
import SettingsPage from "./components/SettingsPage";
import EmployeeNavbar from "./Layout/EmployeeNavbar";
import EmpSettingPage from "./components/EmpSettingPage";
import ViewDetails from "./components/ViewDetails";
import TeamCRUD from "./masters/Team";
import ProjectCRUD from "./masters/Project";
import ManagerNavbar from "./Layout/ManagerNavbar";
import TeamPage from "./components/TeamPage";
import ManagerTeamLeaves from "./components/ManagerTeamLeaves";
import ManagerSettings from "./components/ManagerSettings";
// import ManageTeam from "./components/ManageTeam";
import AdminManageTeams from "./components/AdminManageTeams";
import ForgotPasswordModal from "./components/ForgotPasswordModal";
import Holiday from "./masters/Holiday";
import EmployeeHolidayPage from "./components/EmployeeHolidayPage";
import ManagerProfile from "./components/ManagerProfile";
import MastersLandingPage from "./admin/MastersLandingPage";
import EmployeeLandingPage from "./admin/EmployeeLandingPage";
import TasksLandingPage from "./admin/TasksLandingPage";
import TimesheetsLandingPage from "./admin/TimesheetsLandingPage";
import LeaveManagementLandingPage from "./admin/LeaveManagementLandingPage";
import ManagerTaskLanding from "./manager/ManagerTaskLanding";
import ManagerTimesheetLanding from "./manager/ManagerTimesheetLanding";
import ManagerLeaveLanding from "./manager/ManagerLeaveLanding";
import ManagerTeamLanding from "./manager/ManagerTeamLanding";
import EmployeeTaskLanding from "./employee/EmployeeTaskLanding";
import EmployeeTimesheetLanding from "./employee/EmployeeTimesheetLanding";
import EmployeeDocumentsLanding from "./employee/EmployeeDocumentsLanding";
import EmployeeLeavesLanding from "./employee/EmployeeLeavesLanding";
import EmployeeDetailsLanding from "./employee/EmployeeDetailsLanding";
import PendingLeaveList from "./components/PendingLeaveList";
import PendingManagerTeamLeaves from "./components/PendingManagerTeamLeaves";
import AllTimesheetGrid from "./components/AllTimesheetGrid";
import EmployeeAssetRequest from "./assetsmanagement/EmpAssets";
import EmployeeProjectsPage from "./tasklayout/EmployeeProjectsPage";
import LeaveManagement from "./components/LeaveManagement";
import ManagerLeaveAppli from "./components/ManagerLeaveAppli";
import ManagerLeaves from "./components/ManagerLeaves";
import ManagerTimesheet from "./components/ManagerTimesheet";
import ManagerDocumentLanding from "./manager/ManagerDocumentLanding";
import ManagerUploadDocs from "./components/ManagerUploadDocs";
import ManagerDocs from "./components/ManagerDocs";
import ManagerDetailsLanding from "./manager/ManagerDetailsLanding";
import ManagerViewDetails from "./components/ManagerViewDetails";
import ManagerHolidayPage from "./components/ManagerHolidayPage";
// import ATasks from "./dashboard/ATasks";
// import UTasks from "./components/UTasks";
// import MTasks from "./components/MTasks";
import AllocationPage from "./components/AllocationPage";
import Tasks from "./components/Tasks";
import Preference from "./components/Preference";
import TermsConditions from "./masters/TermsConditions";
import BalsuiteApp from "./components/Balsuite";
import EmployeeEvaluation from "./components/EmployeeEvaluation";
import ManagerEvaluation from "./components/ManagerEvaluation";
import AdminIntegrationConfig from "./components/AdminIntegrationConfig";
import ExternalIntegration from "./components/ExternalIntegration";
import IntegrationLandingPage from "./admin/IntegrationLandingPage";
import AdminPermissions from "./permissions/AdminPermissions";
import PagePermissionRoute from "./permissions/PagePermissionRoute";
import Announcement from "./announcement/Announcement";
import AlertsLanding from "./announcement/AlertsLanding";
import PermissionsLandingPage from "./admin/PermissionsLandingPage";
import CustomerManagement from "./masters/CustomerManagement";
import AllProjects from "./project/AllProjects";
import NewProject from "./project/NewProject";
import EditProject from "./project/EditProject";
import ViewProject from "./project/ViewProject";
import AllCustomers from "./customer/AllCustomers";
import NewCustomer from "./customer/NewCustomer";
import EditCustomer from "./customer/EditCustomer";
import ViewCustomer from "./customer/ViewCustomer";
import ListLandingPage from "./admin/ListLandingPage";
import SetupLandingPage from "./admin/SetupLandingPage";
import AllContacts from "./customer/AllContacts";
import EditContact from "./customer/EditContact";
import ViewContact from "./customer/ViewContact";
import NewContact from "./customer/NewContact";
import AdminSprintPage from "./sprint/Adminsprintpage";
import NewAsset from "./assetsmanagement/NewAsset";
import AllAssets from "./assetsmanagement/AllAssets";
import EditAsset from "./assetsmanagement/EditAsset";
import ViewAsset from "./assetsmanagement/ViewAsset";
import PendingApprovalsPage from "./assetsmanagement/PendingApprovalsPage";
import AssetReportsPage from "./assetsmanagement/AssetReportsPage";
import AllVendors from "./assetsmanagement/AllVendors";
import NewVendor from "./assetsmanagement/NewVendor";
import EditVendor from "./assetsmanagement/EditVendor";
import ViewVendor from "./assetsmanagement/ViewVendor";
import AdminAssetLanding from "./assetsmanagement/AdminAssetLanding";
import AssetFieldMasterPage from "./assetsmanagement/AssetFieldMasterPage";
import ManagerAssetLanding from "./assetsmanagement/ManagerAssetLanding";
import EmpAssetLanding from "./assetsmanagement/EmpAssetLanding";
import AllAllocations from "./assetsmanagement/AllAllocations";
import NewAllocation from "./assetsmanagement/NewAllocation";
import AllTransfers from "./assetsmanagement/AllTransfers";
import NewTransfer from "./assetsmanagement/NewTransfer";
import AllMaintenance from "./assetsmanagement/AllMaintenance";
import NewMaintenance from "./assetsmanagement/NewMaintenance";
import AllAuditRecords from "./assetsmanagement/AllAuditRecords";
import NewAuditRecord from "./assetsmanagement/NewAuditRecord";
import PendingApprovals from "./assetsmanagement/PendingApprovals";
import ApprovalHistory from "./assetsmanagement/ApprovalHistory";
import ViewAllocation from "./assetsmanagement/ViewAllocation";
import ViewAuditRecord from "./assetsmanagement/ViewAuditRecord";
import ViewMaintenance from "./assetsmanagement/ViewMaintenance";
import ViewTransfer from "./assetsmanagement/ViewTransfer";
import EditAllocation from "./assetsmanagement/EditAllocation";
import EditMaintenance from "./assetsmanagement/EditMaintenance";
import EditTransfer from "./assetsmanagement/EditTransfer";
import EditAuditRecord from "./assetsmanagement/EditAuditRecord";
import AssetPermissionRoute from "./assetsmanagement/AssetPermissionRoute";
import PricingPage from "./pages/PricingPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import WhyBalsuitePage from "./pages/WhyBalsuitePage";
import AllDeletedEntries from "./admin/AllDeletedEntries";
import AdminExpenseDashboard from "./expense/AdminExpenseDashboard";
import EmployeeExpenseDashboard from "./expense/EmployeeExpenseDashboard";
import ManagerExpenseDashboard from "./expense/ManagerExpenseDashboard";
import ChatbotWidget from "./components/ChatbotWidget";
import TokenExpiryWatcher from "./TokenExpiryWatcher";
import LeaveView from "./components/LeaveView";


function App() {
  const withAssetPermission = (element) => (
    <AssetPermissionRoute>{element}</AssetPermissionRoute>
  );
  const withPagePermission = (element, pageKey, deniedMessage) => (
    <PagePermissionRoute pageKey={pageKey} deniedMessage={deniedMessage}>
      {element}
    </PagePermissionRoute>
  );

  return (
    <Router>
      <TokenExpiryWatcher />
      <Routes>
        <Route path="/" element={<BalsuiteApp />} />
        <Route path="/login" element={<LoginPage />} />
        {/* <Route path="/register" element={<RegisterPage />} /> */}
        <Route path="/empdashboard" element={<EmpProtectedRoute allowedRoles={["ROLE_USER"]}><EmpDashboard /></EmpProtectedRoute>} />
        <Route path="/leave" element={<RequestLeaveForm />} />
        <Route path="/allleaves" element={<AllLeaves />} />
        <Route path="/admindashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/approveleave" element={<ApproveLeaveRequests />} />
        <Route path="/addemployee" element={<ProtectedRoute><AddEmployee /></ProtectedRoute>} />
        <Route path="/allemployee" element={<AllEmployees />} />
        <Route path="/editemployee/:id" element={<EditEmployee />} />
        <Route path="/uploaddocs" element={<UploadDocuments />} />
        <Route path="/certification" element={<TrainingForm />} />
        <Route path="/department" element={<DepartmentForm />} />
        <Route path="/designation" element={<DesignationForm />} />
        <Route path="/leavetype" element={<LeaveTypeForm />} />
        <Route path="/document" element={<DocumentCRUD />} />
        <Route path="/uploaddocuments" element={<UploadDocument />} />
        <Route path="/viewdocuments" element={<ViewDocuments />} />
        <Route path="/role" element={<RoleCRUD />} />
        <Route path="/editprofile" element={<EditProfile />} />
        <Route path="/managerdashboard" element={<ManagerDashboard />} />
        <Route path="/viewtasks" element={<ViewTasks />} />
        <Route path="/viewtaskss/:taskId" element={<ViewTaskss />} />
        <Route path="/viewtaskss" element={<ViewTaskss />} />
        {/* <Route path="/registeremployee" element={<RegisterEmployee />} /> */}
        {/* <Route path="/manageusers" element={<ManageUsers />} /> */}
        <Route path="/leavelist" element={<LeaveList />} />
        <Route path="/hrdashboard" element={<HRDashboard />} />
        {/* <Route path="/assignleaves" element={<AssignLeaves />} /> */}
        {/* <Route path="/viewleavecredit" element={<ViewLeaveCreditLogs />} /> */}
        <Route path="/viewalldocs" element={<AdminDocuments />} />
        <Route path="/adminviewtasks" element={<AdminViewTasks />} />
        {/* <Route path="/adminreports" element={<AdminReports />} /> */}
        <Route path="/timesheetgrid" element={<TimesheetGrid />} />
        <Route path="/task/:taskId" element={<ViewTasks />} />
        <Route path="/task/id" element={<ViewTasks />} />
        {/* <Route path="/viewtasks/tasks/:taskId/comments" element={<ViewTasks />} /> */}
        <Route path="/admintimesheetgrid" element={withPagePermission(<AdminTimesheetGrid />, "analytics", "You do not have access to Timesheet Analytics.")} />
        <Route path="/managertimesheetgrid" element={<ManagerTimesheetGrid />} />
        <Route path="/managertimesheetgrid/:managerId" element={<ManagerTimesheetGrid />} />
        {/* <Route path="/hrlettergenerator" element={<HRLetterGenerator />} /> */}
        {/* <Route path="/kanbanboard" element={<KanbanBoard />} /> */}
        {/* <Route path="/employeefacilities" element={<EmployeeFacilities />} /> */}
        {/* <Route path="/managerfacilities" element={<ManagerFacilities />} /> */}
        {/* <Route path="/adminfacilities" element={<AdminFacilities />} /> */}
        <Route path="/adminprofile" element={<AdminProfile />} />
        <Route path="/teamtimesheetgrid" element={<TeamTimesheetGrid />} />
        <Route path="/teamtimesheetgrid/:managerId" element={<TeamTimesheetGrid />} />
        <Route path="/adminnavbar" element={<AdminNavbar />} />
        <Route path="/viewemployee/:id" element={<EmployeeView />} />
        <Route path="/settingpage" element={<SettingsPage />} />
        <Route path="/employeenavbar" element={<EmployeeNavbar />} />
        <Route path="/empsettingpage" element={<EmpSettingPage />} />
        <Route path="/viewdetails" element={<ViewDetails />} />
        <Route path="/team" element={<TeamCRUD />} />
        <Route path="/project" element={<ProjectCRUD />} />
        <Route path="/managernavbar" element={<ManagerNavbar />} />
        <Route path="/teampage" element={<TeamPage />} />
        <Route path="/managerteamleaves" element={<ManagerTeamLeaves />} />
        <Route path="/managersettings" element={<ManagerSettings />} />
        {/* <Route path="/manageteam" element={<ManageTeam />} /> */}
        <Route path="/adminmanageteams" element={<AdminManageTeams />} />
        <Route path="/forgotpassword" element={<ForgotPasswordModal />} />
        <Route path="/holiday" element={<Holiday />} />
        <Route path="/holidays" element={<EmployeeHolidayPage />} />
        <Route path="/managerprofile" element={<ManagerProfile />} />
        <Route path="/masterslanding" element={<MastersLandingPage />} />
        <Route path="/employeelanding" element={<EmployeeLandingPage />} />
        <Route path="/admintasklanding" element={<TasksLandingPage />} />
        <Route path="/admintimesheetlanding" element={<TimesheetsLandingPage />} />
        <Route path="/adminleavemanagementlanding" element={<LeaveManagementLandingPage />} />
        <Route path="/managertasklanding" element={<ManagerTaskLanding />} />
        <Route path="/managertimesheetlanding" element={<ManagerTimesheetLanding />} />
        <Route path="/managerleavelanding" element={<ManagerLeaveLanding />} />
        <Route path="/managerteamlanding" element={<ManagerTeamLanding />} />
        <Route path="/employeetasklanding" element={<EmployeeTaskLanding />} />
        <Route path="/employeetimesheetlanding" element={<EmployeeTimesheetLanding />} />
        <Route path="/employeedocumentslanding" element={<EmployeeDocumentsLanding />} />
        <Route path="/employeeleavelanding" element={<EmployeeLeavesLanding />} />
        <Route path="/employeedetailslanding" element={<EmployeeDetailsLanding />} />
        <Route path="/pendingleavelist" element={<PendingLeaveList />} />
        <Route path="/pendingmanagerteamleaves" element={<PendingManagerTeamLeaves />} />
        <Route path="/alltimesheetgrid" element={<AllTimesheetGrid />} />
        <Route path="/empassets" element={<EmployeeAssetRequest />} />
        <Route path="/empprojtask/:id" element={<EmployeeProjectsPage />} />
        <Route path="/adminviewtasks/:taskId" element={<AdminViewTasks />} />
        <Route path="/leavemanagement" element={<LeaveManagement />} />
        <Route path="/managerleaveappli" element={<ManagerLeaveAppli />} />
        <Route path="/managerleaves" element={<ManagerLeaves />} />
        <Route path="/managertimesheet" element={<ManagerTimesheet />} />
        <Route path="/managerdocumentlanding" element={<ManagerDocumentLanding />} />
        <Route path="/manageruploaddocs" element={<ManagerUploadDocs />} />
        <Route path="/managerdocs" element={<ManagerDocs />} />
        <Route path="/managerdetailslanding" element={<ManagerDetailsLanding />} />
        <Route path="/managerviewdetails" element={<ManagerViewDetails />} />
        <Route path="/mholidays" element={<ManagerHolidayPage />} />
        {/* <Route path="/atasks" element={<ATasks/>}/>
        <Route path="/utasks" element={<UTasks/>}/>
        <Route path="/mtasks" element={<MTasks/>}/> */}
        <Route path="/allocation" element={<AllocationPage />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/preference" element={<Preference />} />
        <Route path="/termconditions" element={<TermsConditions />} />

        
        <Route path="/why-balsuite" element={<WhyBalsuitePage />} />
        {/* <Route path="/pricing" element={<PricingPage />} /> */}
        <Route path="/pricing" element={<ComingSoonPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/cookies" element={<CookiePolicyPage />} />
        <Route path="/blog" element={<ComingSoonPage />} />
        <Route path="/changelog" element={<ComingSoonPage />} />
        <Route path="/roadmap" element={<ComingSoonPage />} />
        <Route path="/help" element={<ComingSoonPage />} />
        <Route path="/status" element={<ComingSoonPage />} />
        <Route path="/community" element={<ComingSoonPage />} />
        <Route path="/security" element={<ComingSoonPage />} />
        <Route path="/careers" element={<ComingSoonPage />} />
        <Route path="/press" element={<ComingSoonPage />} />
        <Route path="/partners" element={<ComingSoonPage />} />

        <Route
          path="/evaluation"
          element={withPagePermission(
            <EmployeeEvaluation />,
            "employee_evaluation",
            "You do not have access to Employee Evaluation."
          )}
        />
        <Route path="/manager-evaluation" element={<ManagerEvaluation />} />
        <Route path="/teamworkint" element={<AdminIntegrationConfig />} />
        <Route path="/jira-tempo-integration" element={<ExternalIntegration />} />
        <Route path="/integrationlanding" element={<IntegrationLandingPage />} />
        <Route path="/permissions" element={<AdminPermissions />} />
        <Route path="/announcement" element={<Announcement />} />
        <Route path="/alertslanding" element={<AlertsLanding />} />
        <Route path="/permissionslanding" element={<PermissionsLandingPage />} />
        <Route path="/deleted-entries" element={<AllDeletedEntries />} />
        <Route path="/customermgmt" element={<CustomerManagement />} />
        <Route path="/allprojects" element={<AllProjects />} />
        <Route path="/addproject" element={<NewProject />} />
        <Route path="/editproject/:id" element={<EditProject />} />
        <Route path="/viewproject/:id" element={<ViewProject />} />
        <Route path="/allcustomers" element={<AllCustomers />} />
        <Route path="/addcustomer" element={<NewCustomer />} />
        <Route path="/editcustomer/:id" element={<EditCustomer />} />
        <Route path="/viewcustomer/:id" element={<ViewCustomer />} />
        <Route path="/listlanding" element={<ListLandingPage />} />
        <Route path="/setuplanding" element={<SetupLandingPage />} />
        <Route path="/allcontacts" element={<AllContacts />} />
        <Route path="/addcontact" element={<NewContact />} />
        <Route path="/viewcontact/:contactId" element={<ViewContact />} />
        <Route path="/editcontact/:contactId" element={<EditContact />} />
        <Route path="/sprints" element={<AdminSprintPage />} />
        <Route path="/newassets" element={withAssetPermission(<NewAsset />)} />
        <Route path="/addasset" element={withAssetPermission(<NewAsset />)} />
        <Route path="/allassets" element={withAssetPermission(<AllAssets />)} />
        <Route path="/editasset/:id" element={withAssetPermission(<EditAsset />)} />
        <Route path="/viewasset/:id" element={withAssetPermission(<ViewAsset />)} />
        <Route path="/asset-field-master" element={withAssetPermission(<AssetFieldMasterPage />)} />
        <Route path="/asset-approvals" element={<PendingApprovalsPage />} />
        <Route path="/asset-reports" element={withAssetPermission(<AssetReportsPage />)} />
        <Route path="/vendors" element={withAssetPermission(<AllVendors />)} />
        <Route path="/addvendor" element={withAssetPermission(<NewVendor />)} />
        <Route path="/editvendor/:id" element={withAssetPermission(<EditVendor />)} />
        <Route path="/viewvendor/:id" element={withAssetPermission(<ViewVendor />)} />
        <Route path="/myassets" element={<EmployeeAssetRequest />} />
        <Route path="/admin-assets" element={withAssetPermission(<AdminAssetLanding />)} />
        <Route path="/manager-assets" element={<ManagerAssetLanding />} />
        <Route path="/emp-assets" element={<EmpAssetLanding />} />
        {/* <Route path="/assetsmgmt" element={withAssetPermission(<AdminAssetLanding />)} /> */}
        {/* Dedicated asset module pages */}
        <Route path="/allallocations" element={withAssetPermission(<AllAllocations />)} />
        <Route path="/newallocation" element={withAssetPermission(<NewAllocation />)} />
        <Route path="/alltransfers" element={withAssetPermission(<AllTransfers />)} />
        <Route path="/newtransfer" element={withAssetPermission(<NewTransfer />)} />
        <Route path="/allmaintenance" element={withAssetPermission(<AllMaintenance />)} />
        <Route path="/newmaintenance" element={withAssetPermission(<NewMaintenance />)} />
        <Route path="/allauditrecords" element={withAssetPermission(<AllAuditRecords />)} />
        <Route path="/newauditrecord" element={withAssetPermission(<NewAuditRecord />)} />
        <Route path="/pendingapprovals" element={withAssetPermission(<PendingApprovals />)} />
        <Route path="/approvalhistory" element={withAssetPermission(<ApprovalHistory />)} />
        <Route path="/viewallocation/:id" element={withAssetPermission(<ViewAllocation />)} />
        <Route path="/editallocation/:id" element={withAssetPermission(<EditAllocation />)} />
        <Route path="/viewauditrecord/:id" element={withAssetPermission(<ViewAuditRecord />)} />
        <Route path="/editauditrecord/:id" element={withAssetPermission(<EditAuditRecord />)} />
        <Route path="/viewmaintenance/:id" element={withAssetPermission(<ViewMaintenance />)} />
        <Route path="/editmaintenance/:id" element={withAssetPermission(<EditMaintenance />)} />
        <Route path="/viewtransfer/:id" element={withAssetPermission(<ViewTransfer />)} />
        <Route path="/edittransfer/:id" element={withAssetPermission(<EditTransfer />)} />

        <Route path="/admin-expenses" element={<ProtectedRoute><AdminExpenseDashboard /></ProtectedRoute>} />
        <Route path="/emp-expenses" element={<EmpProtectedRoute allowedRoles={["ROLE_USER"]}><EmployeeExpenseDashboard /></EmpProtectedRoute>} />
        <Route path="/manager-expenses" element={<ManagerExpenseDashboard />} />

        <Route path="/leavesummary" element={withPagePermission(<LeaveView />, "leave_summary", "You do not have permission to access Leave Summary.")} />
        
      </Routes>

      <ChatbotWidget />

      {/* ToastContainer should be outside Routes */}
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />

    </Router>
  );
}

export default App;
